export const USER_PASSWORD_UPDATED = 'User Password Updated';
export const USER_PROFILE_UPDATED = 'User Profile Updated';
export const USER_PAYMENT_UPDATED = 'User Payment Updated';
export const USER_NOTIFICATIONS_SEEN = 'User Notifications Seen';
export const USER_SUBSCRIPTION_CANCELLED = 'User Subscription Cancelled';